import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Typography } from '@/components/DesignSystem';
import { Button } from '@/components/Sections/Profile/Buttons';

export const LiquidIDAddPromptWrapper = styled(motion.div)`
    position: fixed;
    bottom: 140px;
    width: max-content;
    max-width: 100vw;
    pointer-events: initial;
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    z-index: 1;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        padding: 0;

        top: 0;
        bottom: 0;
        left: 50vw;
        right: 0;
        width: 50vw;
        height: 100vh;
        min-width: max-content;
        align-items: flex-start;
        justify-content: center;
        row-gap: 40px;

        > * {
            transform: translateY(-80px);
        }
    }
`;

export const StyledTitle = styled(Typography)`
    font-size: 25px !important; // Typography component does not support sizes according to breakpoint
    text-shadow:
        0 0 15px rgba(255, 255, 255, 0.45),
        0 0 20px #523df1;

    display: flex;
    align-items: center;
    column-gap: 10px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: 640px;
        font-size: 91px !important;
        margin: 30px 0 10px;
        display: block;
        align-items: initial;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        max-width: 30vw;
    }
`;

export const StyledButton = styled(Button)`
    &&& {
        @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
            display: none;
        }
    }
`;

export const ThumbnailsMessage = styled(Typography)`
    display: block;
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
    }
`;
